"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UseLoanQuery = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var cashLoanAuth_1 = require("../../model/cashLoanAuth");
var service_1 = require("../../../library/base/service");
var UseLoanQuery = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(UseLoanQuery, _super);
    function UseLoanQuery() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '用信结果查询';
        _this.code = '101133';
        _this.desc = '用信结果查询';
        _this.requestParams = new cashLoanAuth_1.UseLoanQueryRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return UseLoanQuery;
}(service_1.BaseService));
exports.UseLoanQuery = UseLoanQuery;
//# sourceMappingURL=useLoanQuery.js.map